import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-layout-content.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UILayoutContent
 * @element ui-layout-content
 * @classdesc Represents a class for <code>ui-layout-content</code> element.
 * @example
 * <ui-layout-content>
 *     <section class="frame">Content</section>
 * </ui-layout-content>
 */
@Component({ tag: 'ui-layout-content', styles })
export class UILayoutContent extends UIElement {
    /**
     * @inheritDoc
     */
    override render(): void {
        this.setAttribute('role', 'main');
    }
}
